import { projectDataType } from ".";

const discreteSystemsData: projectDataType = {
  path: "dicretesystems",
  title: "Discrete Systems",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964783/Art-Site/DiscreteSystems/screen-shot-2014-05-23-at-102521-am-1024x524_roh08o.jpg",
  description: "Solo show at Transfer Gallery",
  year: 2013,
  videos: [
    "https://vimeo.com/manage/videos/99430071",
    "https://vimeo.com/manage/videos/110845833",
  ],
  projectPhotos: [
    "Art-Site/DiscreteSystems/discretesystems-ringblob-grid-full90f-05-29-14_ulxffs.gif",
    "Art-Site/DiscreteSystems/mirrorblob-ingrid-05-08-14_lhu4kg.gif",
    "Art-Site/DiscreteSystems/spherification-helixfunnel-lilacjune-06-28-14_j1ezmm.gif",
    "Art-Site/DiscreteSystems/discretesystems-glitchblob-06-28-14-lg_x5x1x3.gif",
    "Art-Site/DiscreteSystems/discretesystems-glitchedsketch-06-28-14_cycuyy.gif",
  ],
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964876/Art-Site/DiscreteSystems/DiscreteSystems-Still-01_nbgrk8.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964882/Art-Site/DiscreteSystems/DiscreteSystems-Still-04_og32cw.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964875/Art-Site/DiscreteSystems/DiscreteSystems-Still-02_wldrq1.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964855/Art-Site/DiscreteSystems/DiscreteSystems-Still-03_asnetk.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964838/Art-Site/DiscreteSystems/DiscreteSystems-Still-05_ovtrwo.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964826/Art-Site/DiscreteSystems/discrete-systems-still_v3epib.jpg",
  ],
};

export default discreteSystemsData;
